// Logo-list Swiper
document.addEventListener('DOMContentLoaded', function () {
  const logoSwiper = new Swiper('.logo-slider-section .logo-slider', {
    slidesPerView: 'auto',
    freeMode: true,
    mousewheel: {
      forceToAxis: true
    },
    a11y: true
    // spaceBetween: 20,
    // breakpoints: {
    //   769: {
    // spaceBetween: 40,
    //   },
    // },
  });
});

// Footer Section(Newsletter input)
document.addEventListener('DOMContentLoaded', function () {
  const footerNewsletterInput = document.querySelector(".footer__block--newsletter input[name='contact[email]']");

  if (footerNewsletterInput) {
    footerNewsletterInput.placeholder = 'Email address';
  }
});

// Hero carousel Section Sliding Effect
document.addEventListener('DOMContentLoaded', function () {
  const heroCarousel = document.querySelectorAll('.js-hero-carousel');
  if (heroCarousel.length) {
    heroCarousel.forEach(function (el, index) {
      el.classList.add(`s${index}`);
      new Swiper(`.js-hero-carousel.s${index}`, {
        slidesPerView: 1,
        autoplay: el.dataset.autoplay == 'true' ? { delay: el.dataset.speed, disableOnInteraction: false } : false,
        effect: 'fade',
        a11y: false,
        // slideActiveClass: "swiper-slider-active-slide",
        fadeEffect: {
          crossFade: true
        },
        autoplayDisableOnInteraction: false,
        loop: true,
        pagination: {
          el: `.js-hero-carousel.s${index} .swiper-pagination`,
          clickable: true
        }
      });
    });
  }
});

// --------------------------------------------| Bipinsingh JS Start |------------------------------------------------ //
// Custom 2-3 col img text under Section Swiper JS

document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.swiper-custom-2-3-col-img-text-under', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    loop: false,
    grabCursor: false,
    breakpoints: {
      390: {
        spaceBetween: 20
      },
      768: {
        spaceBetween: 30
      }
    }
  });
});

// ---------------------------------------------| Bipinsingh JS End |------------------------------------------------- //

//read more metafield text js
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.toggle-button').forEach(function (button) {
    button.addEventListener('click', function () {
      const targetId = button.getAttribute('data-toggle-target');
      const metaTextContent = document.getElementById(targetId);

      if (!metaTextContent) return;

      // Add toggle-content class if not present
      if (!metaTextContent.classList.contains('toggle-content')) {
        metaTextContent.classList.add('toggle-content');
        // Set initial max-height for animation
        if (metaTextContent.hasAttribute('hidden')) {
          metaTextContent.style.maxHeight = '0';
          metaTextContent.style.opacity = '0';
        } else {
          metaTextContent.style.maxHeight = metaTextContent.scrollHeight + 'px';
        }
      }

      const isHidden = metaTextContent.hasAttribute('hidden');
      if (isHidden) {
        // Open animation
        metaTextContent.removeAttribute('hidden');
        metaTextContent.style.maxHeight = metaTextContent.scrollHeight + 'px';
        metaTextContent.style.opacity = '1';
        button.textContent = 'Read Less';
      } else {
        // Close animation
        metaTextContent.style.maxHeight = '0';
        metaTextContent.style.opacity = '0';
        // Delay setting hidden attribute until animation completes
        setTimeout(() => {
          metaTextContent.setAttribute('hidden', '');
        }, 300); // Match transition duration (0.3s)
        button.textContent = 'Read More';
      }
    });
  });
});

// ---------------------------------------------| Vault Grade FIlter |------------------------------------------------- //

var GradeFilterButton = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const metafieldValue = this.getAttribute('data-metafield');
      const metaobjectValue = this.getAttribute('data-metaobject');
      const section_id = this.getAttribute('data-section-id');
      const url = new URL(window.location.href);

      if (metafieldValue === 'all') {
        url.searchParams.delete(metafieldValue);
      } else {
        url.searchParams.set(metafieldValue, metaobjectValue);
        url.searchParams.set('section_id', section_id);
      }

      this.dispatchEvent(
        new CustomEvent('facet:update', {
          bubbles: true,
          detail: {
            url: url
          }
        })
      );
    });
  }
};
if (!window.customElements.get('grade-filter-button')) {
  window.customElements.define('grade-filter-button', GradeFilterButton);
}
export { GradeFilterButton };

// Vault Countdown Timer
document.addEventListener('DOMContentLoaded', function () {
  const countdownElements = document.querySelectorAll('.vault-countdown');
  if (countdownElements.length > 0) {
    countdownElements.forEach(function (countdownElement) {
      const endTimeUnix = parseInt(countdownElement.getAttribute('data-end-time'), 10);
      if (endTimeUnix) {
        updateVaultCountdown(countdownElement, endTimeUnix);
        const countdownInterval = setInterval(function () {
          const shouldContinue = updateVaultCountdown(countdownElement, endTimeUnix);
          if (!shouldContinue) {
            clearInterval(countdownInterval);
            location.reload();
          }
        }, 1000);
      }
    });
  }
});

function updateVaultCountdown(element, endTimeUnix) {
  const now = Math.floor(Date.now() / 1000);
  const timeRemaining = endTimeUnix - now;
  if (timeRemaining <= 0) {
    return false;
  }
  const days = Math.floor(timeRemaining / 86400);
  const hours = Math.floor((timeRemaining % 86400) / 3600);
  const minutes = Math.floor((timeRemaining % 3600) / 60);
  const seconds = Math.floor(timeRemaining % 60);
  element.querySelector('.days').textContent = padVaultZero(days);
  element.querySelector('.hours').textContent = padVaultZero(hours);
  element.querySelector('.minutes').textContent = padVaultZero(minutes);
  element.querySelector('.seconds').textContent = padVaultZero(seconds);
  return true;
}

function padVaultZero(num) {
  return num < 10 ? '0' + num : num;
}

// Vault Countdown Banner Height Observer
document.addEventListener('DOMContentLoaded', function () {
  const heightObserver = document.querySelector('height-observer');
  const vaultBanner = document.querySelector('.vault-timer-banner');
  if (heightObserver && vaultBanner) {
    function updateHeightObserverPadding() {
      const bannerHeight = vaultBanner.offsetHeight + 100;
      heightObserver.style.paddingBottom = bannerHeight + 'px';
    }

    // // Initial set
    // updateHeightObserverPadding();

    // // Listen for height changes using ResizeObserver
    // const resizeObserver = new window.ResizeObserver(updateHeightObserverPadding);
    // resizeObserver.observe(vaultBanner);
  }
});

// Vault: toggle login/recover forms via URL hash
document.addEventListener('DOMContentLoaded', function () {
  var vaultLogin = document.getElementById('vault-login');
  var recover = document.getElementById('vault-recover');

  if (!vaultLogin || !recover) return;

  function showRecover() {
    recover.hidden = false;
    vaultLogin.hidden = true;
  }

  function showLogin() {
    vaultLogin.hidden = false;
    recover.hidden = true;
  }

  function updateFromHash() {
    if (window.location.hash === '#vault-recover') {
      showRecover();
    } else {
      showLogin();
    }
  }

  // Initialize and listen for changes
  updateFromHash();
  window.addEventListener('hashchange', updateFromHash);
});
